import React, { createContext, useContext, useLayoutEffect, useState } from 'react';

const ThemeContext = createContext({ mode: 'light', brand: 'teal', setMode: () => {}, setBrand: () => {} });
const readPreference = (key, allowed, fallback) => {
  try {
    const value = localStorage.getItem(key);
    return allowed.includes(value) ? value : fallback;
  } catch { return fallback; }
};

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => readPreference('admin-ui-mode', ['light', 'dark'], 'light'));
  const [brand, setBrand] = useState(() => readPreference('admin-ui-brand', ['teal', 'indigo'], 'teal'));
  useLayoutEffect(() => {
    document.documentElement.dataset.adminMode = mode;
    document.documentElement.dataset.adminTheme = brand;
    try {
      localStorage.setItem('admin-ui-mode', mode);
      localStorage.setItem('admin-ui-brand', brand);
    } catch { /* Themes still work when browser storage is unavailable. */ }
  }, [mode, brand]);
  return <ThemeContext.Provider value={{ mode, brand, setMode, setBrand }}>{children}</ThemeContext.Provider>;
}

export const useAdminTheme = () => useContext(ThemeContext);
